import React from 'react';
import PropTypes from 'prop-types';
import {Redirect} from 'react-router-dom';

const NotAuthorized = ({redirectPath}) => {
    return <Redirect to={redirectPath}/>;
};

NotAuthorized.propTypes = {
    redirectPath: PropTypes.string
};

export default NotAuthorized;
